import IconButton from "../../gui/Button/IconButton";
import CloseIcon from "../../gui/Icons/CloseIcon";
import { useOverlay } from "../../gui/Overlay/OverlayProvider";

export default function DialogTitle(props:{overlayId:string,title:string}) {
    const {popOverlay} = useOverlay()
    const onClose = () => popOverlay(props.overlayId)
    return <div className="title flex between">
        <h2>{props.title}</h2>
        <IconButton onClick={onClose}><CloseIcon/></IconButton>
    </div>
}